// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","modal":"_8fIkPo4cKMEa"};